






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Partner } from '@/types/operation'
import { getBoUrl } from '@/api/http-constants'

@Component
export default class Partenaires extends Vue {
    @Prop() partners!: Partner[]

    getImage(imagePath: string): string {
        return `${getBoUrl()}${imagePath}`
    }
}
